const FallWintTypes = {
  FETCH_FALL_WINTER_MAGNITUDE_BP_OBJECT:
    'FETCH_FALL_WINTER_MAGNITUDE_BP_OBJECT',
  REMOVE_FALL_WINTER_MAGNITUDE_BP_OBJECT:
    'REMOVE_FALL_WINTER_MAGNITUDE_BP_OBJECT',
};

export default FallWintTypes;



// WEBPACK FOOTER //
// ./src/action-types/fallWinter.js